import { Product } from '~/types/interfaces/entitites/ProductInterface';
import { Bank } from '~/types/interfaces/entitites/BankInterface';
import { Court } from '~/types/interfaces/entitites/CourtInterface';
import { Judge } from '~/types/interfaces/entitites/JudgeInterface';
import { Lawyer } from '~/types/interfaces/entitites/LawyerInterface';
import { Audience } from '~/types/interfaces/entitites/AudienceInterface';

export interface JudicialPrecedent {
  hash: string;
  slug: string;
  name: string;
  is_favorable: boolean;
  created_at: string;

  instances: JudicialPrecedentInstance[];
  latest_instance: JudicialPrecedentInstance;
  affected_type: JudicialPrecedentAffectedType;
  bank: Bank;
  product: Product;
  lawyers: Lawyer[];
}

export interface JudicialPrecedentSaveRequest {
  bank_hash: string;
  product_hash: string;
  judicial_precedent_affected_type_id_hash: string;
  court_hash: string;
  lawyers: string;
  notes: string;
  is_asufin: boolean;
  is_favorable: boolean;
  file: File;
}

export interface JudicialPrecedentAffectedTypeSaveRequest {
  name: string;
}

export interface JudicialPrecedentAffectedType {
  hash: string;
  slug: string;
  name: string;
}

export interface JudicialPrecedentInstance {
  hash: string;
  file_url: string;
  file_name: string;
  court_number: string;
  notes: string;
  is_revoke: boolean;
  is_favorable: boolean;
  date: string;
  date_demand: string;
  created_at: string;

  judges: Judge[];

  type: JudicialPrecedentInstanceType;
  court: Court;
  audience: Audience;
  judicial_precedent: JudicialPrecedent;
}

export interface JudicialPrecedentInstanceType {
  id: number;
  hash: string;
  slug: string;
  name: string;
  created_at: string;
}

export enum INSTANCE_TYPES_AVAILABLE {
  'FIRST' = 1,
  'SECOND' = 2,
  'THIRD' = 3
}

export interface JudicialPrecedentFilters {
  search: string;
  'product_hash[]': Array<string>;
  'bank_hash[]': Array<string>;
  'court_hash[]': Array<string>;
  year: string;
  asufin: string;
  favorable: string;
  order_by: string;
  sort_by: string;
}
